import { defineStore } from 'pinia';
import { ref } from 'vue';
import { diContainer } from '@/coreContainer/container';
import { OrderTemplateSummaryEntity } from '../domains/entities/orderTemplate';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { INetworkResult } from '@/coreDomainsModule/networkResult';

/**
 * 発注テンプレート一覧ページ用のストア
 */
export const useOrderTemplateListStore = defineStore('orderTemplateListStore', () => {
  const templates = ref<OrderTemplateSummaryEntity[]>([]);
  const loading = ref(false);
  const error = ref<IError | null>(null);

  /**
   * テンプレート一覧を取得する
   */
  const fetchTemplates = async (): Promise<void> => {
    loading.value = true;
    error.value = null;

    const result = await diContainer.getOrderTemplateListUseCase.Execute();
    if (result.status.type === 'success') {
      templates.value = result.status.data;
    } else {
      error.value = result.status.error;
    }

    loading.value = false;
  };

  /**
   * テンプレートを削除する
   * @param templateId - 削除対象のテンプレートID
   */
  const deleteTemplate = async (templateId: string): Promise<INetworkResult<void, IError>> => {
    const result = await diContainer.deleteOrderTemplateUseCase.Execute(templateId);
    if (result.status.type === 'success') {
      templates.value = templates.value.filter((template) => template.templateId !== templateId);
      return { status: { type: 'success', data: undefined } };
    }
    return result;
  };

  return {
    templates,
    loading,
    error,
    fetchTemplates,
    deleteTemplate,
  };
});
